module.exports = __webpack_public_path__ + "media/images/lb/950-86bf31511db6ab04c5117f4e412341c5.svg";